import type { SVGProps } from "react";
import * as React from "react";

const SvgBarChart2 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M17 20a1 1 0 1 0 2 0zm2-10a1 1 0 1 0-2 0zm-8 10a1 1 0 1 0 2 0zm2-16a1 1 0 1 0-2 0zM5 20a1 1 0 1 0 2 0zm2-6a1 1 0 1 0-2 0zm12 6V10h-2v10zm-6 0V4h-2v16zm-6 0v-6H5v6z"
    />
  </svg>
);
export default SvgBarChart2;
